// User reducer
const initialState = {
  allowedLanguages: {
    en: false,
    fr: false,
    nl: false
  },
  selectedUsers: [],
  role: "REDACTOR",
  filter: {
    role: "ALL",
    searchWord: ""
  },
  sidebarOpened: false
};

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SELECTED_USERS": {
      return { ...state, selectedUsers: action.selectedUsers };
    }
    case "SET_ROLE": {
      return { ...state, role: action.role };
    }
    case "SET_ALLOW_LANGUAGE": {
      switch (action.language) {
        case "EN":
          return {
            ...state,
            allowedLanguages: { ...state.allowedLanguages, en: action.value }
          };
        case "FR":
          return {
            ...state,
            allowedLanguages: { ...state.allowedLanguages, fr: action.value }
          };
        case "NL":
          return {
            ...state,
            allowedLanguages: { ...state.allowedLanguages, nl: action.value }
          };
        default:
          return state;
      }
    }
    case "SELECT_ROLE": {
      return { ...state, filter: { ...state.filter, role: action.role } };
    }
    case "SELECT_SEARCH_WORD": {
      return {
        ...state,
        filter: { ...state.filter, searchWord: action.searchWord }
      };
    }
    case "SETTINGS_OPEN_SIDEBAR": {
      return {
        ...state,
        sidebarOpened: true
      };
    }
    case "SETTINGS_CLOSE_SIDEBAR": {
      return {
        ...state,
        sidebarOpened: false
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/setting.js